import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/transformations')({
  component: () => <Outlet />,
});